// Print version of the Games tab: a page per field, a day per group

import GameReportGroup from './GameReportGroup';
import GameReportSection from './GameReportSection';
import GameReportPageTop from './GameReportPageTop';
import { useGameReport } from '../utils/hooks';
import {
  getGamesByField,
  countGames,
  totalGamesOn,
} from '../utils/gameReport';
import './GameReportPDF.scss';

export default function GameListPDF({ id, colorLegend }) {
  const { days, sortedGames, sortedFields } = useGameReport(id);

  return (
    <div className='game-report-pdf'>
      <GameReportPageTop id={id} colorLegend={colorLegend} />
      {days.map((day, i) => {
        const gamesByField = getGamesByField(sortedGames, day, sortedFields);

        return (
          <GameReportGroup
            key={i}
            className={i === 0 ? undefined : 'new-page'}
            total={totalGamesOn(day.format('MMMM D'), countGames(gamesByField))}
          >
            {gamesByField.map(({ field, games }, fieldIndex) => {
              const section = (
                <GameReportSection
                  title={field.name}
                  total={totalGamesOn(field.name, games.length)}
                  games={games}
                  fields={sortedFields}
                  colorLegend={colorLegend}
                  noFieldCol
                />
              );

              // The day header must stay on the same page as the first table
              return fieldIndex === 0 ? (
                <div className='day-header-wrap' key={field.id}>
                  <h4 className='header'>{day.format('MMMM D, YY')}</h4>
                  {section}
                </div>
              ) : (
                <div className='new-page' key={field.id}>
                  {section}
                </div>
              );
            })}
          </GameReportGroup>
        );
      })}
    </div>
  );
}
